import { render, staticRenderFns } from "./ProductDesignFormFabricEdit.vue?vue&type=template&id=fe13e060&"
import script from "./ProductDesignFormFabricEdit.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormFabricEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports